//EXPORT COMPONENT LABELS
const GLOBAL = {
  BRAND: 'Dumpert',
  MENU: 'Menu',
  DUMP: 'Uploaden',
  NEW: 'Nieuw',
  TOPPERS: 'Toppers',
  CONDITIONS: 'Voorwaarden',
  HOUSERULES: 'Huisregels',
  PRIVACY: 'Privacy & Cookies',
  CONTACT: 'Contact',
  RSS: 'RSS',
  FLOPPERS: 'Floppers',
};

export const HEADER =  {
  ITEM: {
    MENU: GLOBAL.MENU,
    DUMP: 'Insturen',
    NEW: GLOBAL.NEW,
    TOPPERS: GLOBAL.TOPPERS,
    SETTINGS: 'Instellingen',
    LOGIN: 'Inloggen',
    LOGOUT: 'Uitloggen',
    SEARCH: 'Zoeken',
    BRAND: GLOBAL.BRAND,
    TV: 'TV',
  },
  SEARCH: {
    PLACEHOLDER: 'Zoeken...',
  },
};

export const FILTER = {
  NEW: GLOBAL.NEW,
  TOP: GLOBAL.TOPPERS,
  TOP_DAY: 'Dag',
  TOP_WEEK: 'Week',
  TOP_MONTH: 'Maand',
  DUMP: GLOBAL.DUMP,
  BRAND: GLOBAL.BRAND,
};

export const PAGINATION = {
  DAY: 'Dag',
  WEEK: 'week',
};

export const MENU = {
  TITLE: {
    MENU: GLOBAL.MENU,
    NAV: 'Navigatie',
    CONTACT_TERMS: 'Contact & voorwaarden',
    SEARCH: 'Zoeken',
    SETTINGS: 'Instellingen',
    SOCIAL: 'Sociale bedoeningen',
  },
  SEARCH: {
    PLACEHOLDER: 'Zoeken...',
  },
  HISTORY_MENU: {
    YESTERDAY: 'Gisteren',
    PREVIOUS_WEEK: 'Vorige week',
  },
  FIRST_POST: '2006-03-20',
  DATE_NAVIGATOR: {
    PLACEHOLDER: 'DD-MM-YYYY',
    BUTTON_TEXT: 'Ga naar datum',
    ERROR_MESSAGES: {
      DEFAULT: 'er gaat iets fout...',
      INVALID_DATE: 'Dit is geen geldige datum (DD-MM-YYYY)',
      MIN_DATE: 'We hebben geen delorean tot onze beschikking, kies een datum later dan 20-03-2006',
      MAX_DATE: 'X Æ A-12 from the future: ga niet naar de toekomst.',
    },
  },
  SINGLE_DAY_NAVIGATOR: {
    PLACEHOLDER: 'Aantal dagen terug',
    BUTTON_TEXT: 'Dagen terug',
    INFO_TEXT: 'Je kan maximaal 365 dagen terug. Wil je verder terug zoeken, gebruik dan een datum.',
    ERROR_MESSAGES: {
      DEFAULT: 'er gaat iets fout...',
      MAX_DATE: maxDays => `Je kan maximaal ${maxDays} dagen terug.`,
      ONLY_NUMBERS: 'Dit veld mag alleen cijfers bevatten.',
    },
  },
  ITEM: {
    HOME: GLOBAL.NEW,
    TOPPERS: GLOBAL.TOPPERS,
    BRAND: `${GLOBAL.BRAND}`,
    FAQS: 'Veelgestelde vragen',
    HOUSERULES: GLOBAL.HOUSERULES,
    CONDITIONS: GLOBAL.CONDITIONS,
    PRIVACY: GLOBAL.PRIVACY,
    ADVERT: 'Adverteren',
    CONTACT: GLOBAL.CONTACT,
    FAPTAG: 'Fapvoer',
    STORE: 'Winkel',
    DUMP: 'Uploaden of linktippen',
    LEGACYMODE: `Oude ${GLOBAL.BRAND}`,
    COOKIESETTINGS: 'Privacy instellingen',
    RSS: GLOBAL.RSS,
    FLOPPERS: GLOBAL.FLOPPERS,
    SHOW_MORE: '▼ Meer items',
    SHOW_LESS: '▲ minder items',
  },
};

export const SETTINGSMENU = {
  TITLE: {
    SETTINGS: 'Instellingen',
    FILTER_ITEMS: 'Filter items op',
    SORT_COMMENTS: 'Sorteer reaguursels',
    VIEW: 'Weergave items',
  },
  OPTIONS: {
    SHOW_NFSW: 'Toon NSFW items',
    UP_NEXT: 'AutoPlay',
    COMMENTS_UNDER_VIDEO: 'Reaguursels onder item',
    HIGHLIGHT_VIEWED: 'Highlight bekeken items',
    SHOW_NIGHTMODE: 'Nachtmodus',
    LABEL: 'Ik wil',
    ALL: 'alles',
    VIDEO: 'filmpjes',
    IMAGES: 'plaatjes',
  },
  VIEW: {
    CARDS: 'Kaarten',
    LIST: 'Lijst',
  },
};

export const SIDEBAR = {
  TITLE: {
    NEW: `${GLOBAL.NEW} op ${GLOBAL.BRAND}`,
    TOP: 'Top 5',
    BRAND: `${GLOBAL.BRAND}TV`,
  },
  BUTTON: {
    NEW: `Meer ${GLOBAL.NEW}e items`,
    TOP: `Meer ${GLOBAL.TOPPERS}`,
    BRAND: `Meer ${GLOBAL.BRAND}TV`,
  },
};

export const ITEMSLIST = {
  PAGINATED: {
    TITLE: {
      NEW_TODAY: 'Vandaag',
      NEW_DAY: 'dag',
      NEW_DAYS: 'dagen',
      NEW_WEEK: 'week',
      NEW_WEEKS: 'weken',
      NEW_AGO: 'Geleden',
    },
    NO_ITEMS: 'Helaas, geen items geplaatst op deze dag.',
  },
  LAZYLOAD: {
    TITLE: {
      TOPPERS_TODAY: `${GLOBAL.TOPPERS} Vandaag`,
      TOPPERS_WEEK: `${GLOBAL.TOPPERS} Deze week`,
      TOPPERS_MONTH: `${ GLOBAL.TOPPERS } Deze maand`,
      YESTERDAY: `${GLOBAL.TOPPERS} Gisteren`,
      PREVIOUS_WEEK: `${ GLOBAL.TOPPERS } Vorige week`,
      PREVIOUS_MONTH: `${GLOBAL.TOPPERS} Vorige maand`,
    },
    SEARCH: {
      TITLE: 'Resultaten voor', // ENDS WITH A TAGID
      SORTED_ON: 'Gesorteerd op:',
      NO_RESULT: {
        TITLE: 'Geen resultaten voor', // ENDS WITH A TAGID
        CONTENT: 'Geen items gevonden. Misschien je zoekterm korter maken...',
        EMPTY: 'Je hebt geen zoekterm ingevuld...',
      },
    },
    NO_MORE_ITEMS: 'Geen items meer',
    LOADING_MORE_ITEMS: 'Meer items inladen',
    SCROLL_MORE_ITEMS: 'Scroll / klik voor meer items',
    NO_RESULT: 'Deze lijst heeft geen resultaten opgeleverd',
  },
};

export const SOCIALBAR = {
  COPIED: 'Link gekopieerd!',
};

export const ITEMMEDIA = {
  NSFW_TEXT: 'Hoi gluurder. Dit item is NSFW. Zet \'Toon NSFW items\' aan om de post te bekijken.',
};

export const LOADINGTEXT = {
  CONTENT: 'inladen...',
};

export const UPLOADFORM = {
  UPLOAD_AREA: 'Klik hier of dump je bestanden.',
  FORM_TITLE: 'Jouw gegevens',
  FILE: 'Bestand',
  NUM_OF_CHARS: ' / 150 karakters',
  TITLE: {
    FORM: GLOBAL.DUMP,
  },
  PLACEHOLDER: {
    NAME: 'Jouw naam*',
    EMAIL: 'Jouw e-mail*',
    TITLE: 'Titel*',
    DESCRIPTION: 'Beschrijving',
  },
  CONDITIONS: {
    ACCEPT: 'Ja, ik accepteer de',
    LINK: 'algemene voorwaarden',
    BUTTON: 'Verstuur',
  },
};

export const TIPFORM = {
  TITLE: 'Tip ons',
  SEND: 'Verstuur',
  SUCCESS: 'Je tip is verzonden, bedankt!',
  ERROR: 'Er gaat iets fout... probeer het nog eens',
  PLACEHOLDER: {
    EMAIL: 'Jouw e-mail*',
    LINK: 'Link*',
    EXTRA: 'Extra omschrijving of tijdstip',
  },
};

export const CONTACTFORM = {
  TITLE: GLOBAL.CONTACT,
  SEND: 'Verstuur',
  SUCCESS: 'Je bericht is verzonden, bedankt!',
  ERROR: 'Er gaat iets fout... probeer het nog eens',
  TIMEOUT: 'Rustaagh! Probeer het nu nog eens',
  PLACEHOLDER: {
    NAME: 'Jouw naam*',
    EMAIL: 'Jouw e-mail*',
    TELEPHONE: 'Telefoonnummer',
    DESCRIPTION: 'Beschrijving',
  },
};

export const AUTOSUGGESTSEARCH = {
  TITLE: 'Zoek hier je video',
  PLACEHOLDER: 'zoek je favoriete video of plak een url',
  NO_RESULTS: {
    TITLE: 'Geen Resultaten.',
    PARAGRAPH: 'Weet je zeker dat het een video en geen foto is?',
  },
};

export const TOPZOVEEL = {
  IMAGES: {
    LOGO: 'https://assets.dumpert.nl/dumpert_topzoveel.png',
    PATTERN: 'https://assets.dumpert.nl/dumpert_topzoveel-pattern.png',
  },
};

export const STEMPAGE = {
  NOTIFICATIONS: {
    ADDED: 'video toegevoegd',
    DOUBLE: 'video staat al in de lijst',
    DELETED: 'video verwijderd',
  },
  CONFIRM: {
    CHOICE: 'Weet je zeker dat dit jouw keuze is?',
    CANCELED: 'Je hebt er voor gekozen je lijst niet te verzenden.',
  },
};

export const STEMINTRODUCTION = {
  TITLE: 'INTRO',
  INTRO_TEXT: `
    Welkom bij het enige ekte stemformulier voor de Dumpert TopZoveel! Het jaar zit er alweer bijna op en om onze 
    TopZoveel-traditie hoog te houden presenteren we jullie graag weer een leuke lijst aan filmpjes op 31 december. 
    <br /><br />
    Op deze pagina kun je stemmen op je favoriete Dumpertfilmpje allertijden. Allertijden ja, dus niet alleen de 
    filmpjes van afgelopen jaar maar neem vooral ook de echte klassiekers mee en misschien weet je nog dat ene 
    verborgen pareltje uit 2015 te vinden. 
    <br /><br />
    Krijg je het met onze zoekfunctie niet voor elkaar (waarschijnlijk niet) probeer het dan vooral via <a 
    href="https://www.google.com/search?q=site%3Adumpert.nl+zoekwoorden" 
    rel="noopener noreferrer" 
    target="_blank">
    Google
    </a> en plak de url in het invulveld. Valsspelen met meerdere accounts, proxies en/of Chinese kinderclickfarms 
    gebruiken heeft geen zin en we diskwalificeren je hele familie de moeder.
    Dus choose wisely, you must, young padawan. <br/><br/>Veel succes, plezier en kusjes Team Dumpert
    <br />
    `,
  BUTTON_LOGOUT: 'Ben jij dit niet?',
  BUTTON_CONTINUE: 'verder',
};

export const STEMFORM = {
  TITLE: 'stemformulier',
  DESCRIPTION: 'Zo werkt het:',
  SUMUP: [
    'Je kunt een zoekwoord opgeven of de complete URL plakken.',
    'Het eerste filmpje dat je bovenin invult, weegt het zwaarst mee in de uiteindelijke lijst, dan de tweede etc...',
    'Geef minimaal vijf filmpjes op. Weet je er meer? Geen probleem, je kunt tot maximaal tien filmpjes opgeven.',
    'Je kunt een video maar één keer insturen.',
    `We willen de lijst graag vlot en voor iedereen leuk houden, daarom is het niet 
    mogelijk om op (lange) compilaties, afleveringen van DFJW of DumpertReeten te stemmen.`,
    'Als je besluit het formulier nog een keer in te vullen wordt je oude selectie vervangen.',
  ],
  SELECTED_VIDEOS: 'Je geselecteerde video\'s',
  MIN_VIDEOS_TEXT: 'Je hebt minimaal 5 filmpjes toegevoegd en kan daarom je formulier versturen.',
  ADD_VIDEOS_TEXT: ' Maar je kan nog {length} filmpjes toevoegen.',
  MAX_VIDEOS_TEXT: ' Je zit aan de max van 10 video\'s en kan geen video\'s meer toevoegen',
  LOADING_TEXT: 'Lijst aan het dumpen...',
  BUTTON: 'verstuur',
};

export const STEMTHANKYOU = {
  TITLE: 'Bedankt!',
  TEXT: 'We hebben je lijst ontvangen en gaan deze verwerken in de enige lijst die er toe doet!',
  BUTTON_CONTINUE: 'Verder met filmpjes kijken',
  BUTTON_LOGOUT: 'Uitloggen',
};

export const FOOTER = {
  CONDITIONS: GLOBAL.CONDITIONS,
  HOUSERULES: GLOBAL.HOUSERULES,
  PRIVACY: GLOBAL.PRIVACY,
  CONTACT: GLOBAL.CONTACT,
  RSS: GLOBAL.RSS,
};

export const LOGINPAGE = {

  LOGIN_BLOCK: {
    TITLE: 'Inloggen',
    TEXT: 'Heb je al een account? Dan kan je hier inloggen.',
  },
  LOGIN_FORM: {
    EMAIL_LABEL: 'Email',
    EMAIL_PLACEHOLDER: 'Emailadres',
    PASSWORD_LABEL: 'wachtwoord',
    PASSWORD_PLACEHOLDER: '*******',
    ERROR: 'Er gaat iets fout, controleer je email en je wachtwoord',
    ERROR_UNCONFIRMED: 'Dit mailadres is nog niet bevestigd',
    FORGOT_PASSWORD: 'Wachtwoord vergeten?',
    PROBLEMS: 'Andere probleem’n?',
    LOADING_TEXT: 'Even de gegevens door de Dumpert databank halen...',
    BUTTON: 'Inloggen',
  },
  REGISTER_BLOCK: {
    TITLE: 'Account aanmaken',
    TEXT: `
      Binnen 30 seconden gepiept. Bekijk ALLE posts en reaguur mee.
    `,
    BUTTON: 'registreren',
  },
};
